// lib/fetcher.ts
import { VacanciesResponse, Vacancy } from '@/interfaces/Vacancies';

/**
 * Generic fetcher that throws on HTTP errors and returns parsed JSON.
 */
export async function fetcher<T>(url: string): Promise<T> {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Fetch error (${res.status}): ${res.statusText}`);
  }
  return res.json();
}

/**
 * Fetcher specifically for /api/jobs.
 * Unwraps the { results: Vacancy[] } envelope and returns Vacancy[].
 */
export async function jobsFetcher(url: string): Promise<Vacancy[]> {
  const data = await fetcher<VacanciesResponse>(url);
  return data.results;
}
